export default "__VITE_ASSET__449699ea__"